export const FacebookIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 12.8184C22 17.8098 18.343 21.9469 13.5625 22.6969V15.709H15.8926L16.3359 12.8184H13.5625V10.9426C13.5625 10.1516 13.95 9.38086 15.1922 9.38086H16.4531V6.91992C16.4531 6.91992 15.3086 6.72461 14.2145 6.72461C11.9305 6.72461 10.4375 8.10898 10.4375 10.6152V12.8184H7.89844V15.709H10.4375V22.6969C5.65703 21.9469 2 17.8098 2 12.8184C2 7.2957 6.47734 2.81836 12 2.81836C17.5227 2.81836 22 7.2957 22 12.8184Z"
        fill="#1877F2"
      />
      <path
        d="M15.8926 15.709L16.3359 12.8184H13.5625V10.9425C13.5625 10.1517 13.9499 9.38086 15.1921 9.38086H16.4531V6.91992C16.4531 6.91992 15.3088 6.72461 14.2146 6.72461C11.9304 6.72461 10.4375 8.10898 10.4375 10.6152V12.8184H7.89844V15.709H10.4375V22.6968C10.9466 22.7767 11.4684 22.8184 12 22.8184C12.5316 22.8184 13.0534 22.7767 13.5625 22.6968V15.709H15.8926Z"
        fill="white"
      />
    </svg>
  );
};
